export const PendingChangesSidebarTestIds = {
  DIRECT_COUNT: 'pending-changes-sidebar.direct-count',
  RECALCULATED_COUNT: 'pending-changes-sidebar.recalculated-count',
};
